module.exports = __webpack_public_path__ + "static/media/pool.0b465cd7.jpg";